import React from 'react'
import { useLocation, useOutlet, Navigate } from 'react-router';
import {Dashboard} from '../components/dashboard.ui'
import { useAuth } from './auth.middleware';



const RouteMiddleware = () => {
  const { token } = useAuth();
  const outlet = useOutlet();
  const location = useLocation()

  if (!token){
    return <Navigate to="/login" state={{path: location.pathname}} />;
  }
  return (
    <div>
      <Dashboard>
        {outlet}
      </Dashboard>
    </div>
  )
}
export default RouteMiddleware
